import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CookieManagerService {
  constructor(private cookieService: CookieService) {}
  private cookieOptions: any = {
    domain: window.location.hostname,
    secure: environment.secure,
    path: '/',
    expires: new Date(2147483647 * 1000),
  };

  public setCookie = (key: string, value: string) => {
    this.cookieService.set(key, value, this.cookieOptions.expires, this.cookieOptions.path, this.cookieOptions.domain, this.cookieOptions.secure);
  };

  public getCookie = (key: string) => this.cookieService.get(key);

  public clearCookie = (key: string) => {
    this.cookieService.delete(key, '/', this.cookieOptions.domain, this.cookieOptions.secure, 'None');
  };

  /*public clearAllCookies = () => {
    this.cookieService.deleteAll(this.cookieOptions.path, this.cookieOptions.domain);
  }*/

  public clearAllCookies = () => {
    this.cookieService.deleteAll(this.cookieOptions.path, this.cookieOptions.domain);
  };
}
